const AppleAppSiteAssociation = () => {
   const appSiteAssociation = {
      webcredentials: {
         apps: ['AD9P7L7XTM.com.golfn.app'],
      },
      applinks: {
         apps: [],
         details: [
            {
               appID: 'AD9P7L7XTM.com.golfn.app',
               paths: ['/VvtS/*', '/', '*'],
            },
         ],
      },
   };

   return <pre style={{ whiteSpace: 'pre-wrap', color: 'black' }}>{JSON.stringify(appSiteAssociation, null, 2)}</pre>;
};

export default AppleAppSiteAssociation;
